module.exports = __webpack_public_path__ + "img/songxiaojie_p.59be8c91.png";